import { Pivot, pivotContainerStylesFill, pivotStylesFill, WidgetPanel, widgetPanelStylesNoBG } from '@h2oai/ui-kit';

import { RecentlyOpenedFeatureSetList } from '../RecentlyOpenedFeatureSetList/RecentlyOpenedFeatureSetList';
import { RecentlyOpenedProjectList } from '../RecentlyOpenedProjectList/RecentlyOpenedProjectList';

export const RecentlyOpenedListWidget = () => {
  return (
    <WidgetPanel
      styles={widgetPanelStylesNoBG}
      title="Recently opened (Top 20)"
      data-test="recently-opened-list-widget"
    >
      <Pivot
        styles={pivotStylesFill}
        pivotContainerStyles={pivotContainerStylesFill}
        items={[
          { headerText: 'Feature Sets', content: <RecentlyOpenedFeatureSetList /> },
          { headerText: 'Projects', content: <RecentlyOpenedProjectList /> },
        ]}
      />
    </WidgetPanel>
  );
};
